import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super()
    this.state = {
      hasError: false
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <h1>Ooops! That isn't good! Broken.</h1>
    }
    return this.props.children;
  }

}

export default ErrorBoundary;